<template>
  <main class="app-main property-map-page">
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">خريطة العقارات</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item">
                <router-link v-if="checkAccess('property_read')" to="/properties">العقارات</router-link>
                <span v-else>العقارات</span>
              </li>
              <li class="breadcrumb-item active" aria-current="page">خريطة العقارات</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="app-content">
      <div class="container-fluid">
        <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />

        <div v-if="hasMapAccess" class="card card-warning card-outline shadow-sm mb-3">
          <div class="card-body">
            <div class="row g-3 align-items-end">
              <div class="col-lg-4 col-md-6">
                <label class="form-label">تصنيف العقار</label>
                <select v-model="filters.category" class="form-select" @change="handleCategoryChange">
                  <option value="">الكل</option>
                  <option value="commercial">تجاري</option>
                  <option value="residential">سكني</option>
                  <option value="agricultural">زراعي</option>
                </select>
              </div>

              <div class="col-lg-4 col-md-6">
                <label class="form-label">الغرض</label>
                <select v-model="filters.purpose" class="form-select" @change="nearProperties(true)">
                  <option value="null">الكل</option>
                  <option value="for_rent">للإيجار</option>
                  <option value="for_sale">للبيع</option>
                  <option value="for_investment">للاستثمار</option>
                </select>
              </div>

              <div class="col-lg-3 col-md-9">
                <label class="form-label">نوع العقار</label>
                <select ref="typesSelect" v-model="filters.typeId" class="form-select">
                  <option value="null">الكل</option>
                  <option v-for="type in filteredTypesList" :key="type.id" :value="type.id">
                    {{ type.name }}
                  </option>
                </select>
              </div>

              <div class="col-lg-1 col-md-3">
                <button type="button" class="btn btn-light w-100" title="مسح الفلاتر" @click="clearFilters">
                  <i class="fa-solid fa-filter-circle-xmark"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="hasMapAccess" class="map-card position-relative">
          <div ref="propertyMap" class="property-map" aria-label="خريطة العقارات"></div>
          <div v-if="!loading" class="map-results-count">
            <i class="bi bi-geo-alt-fill"></i>
            {{ rows.length }} عقار
          </div>
          <div v-if="loading" class="map-loading">
            <div class="spinner-border text-primary" role="status"></div>
            <span>جاري تحميل العقارات...</span>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import { checkAccess } from '@/helpers/tools';
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import 'select2';
import 'select2/dist/css/select2.min.css';

export default {
  name: 'PropertiesMap',
  data(){
    return {
      latitude: 24.7136,
      longitude: 46.6753,
      map: null,
      infoWindow: null,
      markers: [],
      mapIdleListener: null,
      mapSearchTimer: null,
      infoWindowDomListener: null,
      googleLoaderTimer: null,
      requestSequence: 0,
      lastRequestedCenter: null,
      rows: [],
      typesList: [],
      filters: {
        category: '',
        purpose: 'null',
        typeId: 'null',
      },
      loading: false,
      hasError: false,
      message: '',
      errorNumber: 0,
      rowsIds: [],
    };
  },
  computed: {
    ...mapGetters(['MEDIA_URL', 'GOOGLE_MAP_API']),
    hasMapAccess(){
      return this.checkAccess('property_map_read');
    },
    filteredTypesList(){
      if(!this.filters.category)
        return this.typesList;
      return this.typesList.filter(type => type.category === this.filters.category);
    },
  },
  methods: {
    checkAccess,
    isGoogleMapsReady(){
      return Boolean(
        window.google &&
        window.google.maps &&
        typeof window.google.maps.Map === 'function'
      );
    },
    loadFilterData(){
      return this.$http.get('/api/admin/properties/init').then(({data}) => {
        this.typesList = data.typesList || [];
        this.$nextTick(() => this.applySelect2Types());
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },
    loadGoogleMaps(){
      if(this.isGoogleMapsReady())
        return Promise.resolve();

      return new Promise((resolve, reject) => {
        let script = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
        if(!script){
          script = document.createElement('script');
          script.src = `https://maps.googleapis.com/maps/api/js?key=${this.GOOGLE_MAP_API}&loading=async&libraries=places`;
          script.async = true;
          script.defer = true;
          document.head.appendChild(script);
        }
        script.addEventListener('error', () => reject(new Error('تعذر تحميل خرائط Google')), {once: true});

        let attempts = 0;
        this.googleLoaderTimer = window.setInterval(() => {
          attempts += 1;
          if(this.isGoogleMapsReady()){
            window.clearInterval(this.googleLoaderTimer);
            this.googleLoaderTimer = null;
            resolve();
          }else if(attempts >= 100){
            window.clearInterval(this.googleLoaderTimer);
            this.googleLoaderTimer = null;
            reject(new Error('تعذر تحميل خرائط Google'));
          }
        }, 100);
      });
    },
    nearProperties(clearMarkers=false){
      if(this.mapSearchTimer){
        window.clearTimeout(this.mapSearchTimer);
        this.mapSearchTimer = null;
      }
      if(this.map){
        const center = this.map.getCenter();
        if(center){
          this.latitude = center.lat();
          this.longitude = center.lng();
        }
      }

      const sequence = ++this.requestSequence;
      this.loading = true;
      this.hasError = false;
      this.lastRequestedCenter = {
        latitude: this.latitude,
        longitude: this.longitude,
      };

      const params = {
        latitude: this.latitude,
        longitude: this.longitude,
        typeId: this.filters.typeId,
        purpose: this.filters.purpose,
        category: this.filters.category,
      };

      return this.$http.get('/api/admin/properties/map', {params}).then(({data}) => {
        if(sequence !== this.requestSequence)
          return;
        if(clearMarkers)
          this.clearMapMarkers();
        if(data.properties){
          for(let i=0; i<data.properties.length; i++){
            if(!this.rowsIds.includes(data.properties[i].id)){
              this.rowsIds.push(data.properties[i].id);
              this.rows.push(data.properties[i]);
              this.renderSingleMarker(data.properties[i]);
            }
          }
        }
        this.loading = false;
      }).catch(err => {
        if(sequence !== this.requestSequence)
          return;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.loading = false;
      });
    },
    initMap(){
      if(!this.$refs.propertyMap || !this.isGoogleMapsReady())
        return;

      if(this.map)
        return;

      this.map = new window.google.maps.Map(this.$refs.propertyMap, {
        center: {lat: this.latitude, lng: this.longitude},
        zoom: 8,
        mapTypeControl: false,
        streetViewControl: false,
      });
      this.infoWindow = new window.google.maps.InfoWindow();
      this.mapIdleListener = this.map.addListener('idle', this.handleMapIdle);
    },
    handleMapIdle(){
      if(!this.map)
        return;

      const center = this.map.getCenter();
      if(!center)
        return;

      const latitude = center.lat();
      const longitude = center.lng();
      const lastCenter = this.lastRequestedCenter;
      if(lastCenter &&
        Math.abs(lastCenter.latitude - latitude) < 0.00001 &&
        Math.abs(lastCenter.longitude - longitude) < 0.00001)
        return;

      if(this.mapSearchTimer)
        window.clearTimeout(this.mapSearchTimer);
      this.mapSearchTimer = window.setTimeout(() => {
        this.latitude = latitude;
        this.longitude = longitude;
        this.nearProperties();
      }, 400);
    },
    renderMarkers(){
      if(!this.map || !this.isGoogleMapsReady())
        return;

      this.markers.forEach(marker => marker.setMap(null));
      this.markers = [];
      if(this.infoWindow)
        this.infoWindow.close();

      this.rows.forEach(row => {
        const latitude = Number(row.latitude);
        const longitude = Number(row.longitude);
        if(!Number.isFinite(latitude) || !Number.isFinite(longitude) ||
          latitude < -90 || latitude > 90 || longitude < -180 || longitude > 180)
          return;

        const marker = new window.google.maps.Marker({
          position: {lat: latitude, lng: longitude},
          map: this.map,
          draggable: false,
          title: row.title || `عقار #${row.id}`,
        });
        marker.addListener('click', () => this.openProperty(row, marker));
        this.markers.push(marker);
      });
    },
    renderSingleMarker(row){
      if(!this.map || !this.isGoogleMapsReady())
        return;

      if(this.infoWindow)
        this.infoWindow.close();

      const latitude = Number(row.latitude);
      const longitude = Number(row.longitude);
      if(!Number.isFinite(latitude) || !Number.isFinite(longitude) ||
        latitude < -90 || latitude > 90 || longitude < -180 || longitude > 180)
        return;

      const marker = new window.google.maps.Marker({
        position: {lat: latitude, lng: longitude},
        map: this.map,
        draggable: false,
        title: row.title || `عقار #${row.id}`,
      });
      marker.addListener('click', () => this.openProperty(row, marker));
      this.markers.push(marker);
    },
    openProperty(row, marker){
      if(!row || !marker || !this.infoWindow)
        return;

      const title = this.escapeHtml(row.title || `عقار #${row.id}`);
      const price = this.escapeHtml(row.price || 0);
      const location = this.escapeHtml(this.propertyLocation(row));
      const image = row.mediaFiles && row.mediaFiles.length
        ? `<img src="${this.escapeHtml(this.MEDIA_URL + row.mediaFiles[0].thumbnail)}" class="property-map-info-image" alt="">`
        : '';
      const area = row.area
        ? `<span><i class="bi bi-aspect-ratio"></i> ${this.escapeHtml(row.area)} م²</span>`
        : '';
      const rooms = row.roomsCount
        ? `<span><i class="bi bi-door-open"></i> ${this.escapeHtml(row.roomsCount)}</span>`
        : '';
      const bathrooms = row.bathrooms
        ? `<span><i class="fa-solid fa-bath"></i> ${this.escapeHtml(row.bathrooms)}</span>`
        : '';
      const content = `
        <div class="property-map-info" dir="rtl">
          ${image}
          <div class="property-map-info-body">
            <strong>${title}</strong>
            <div class="property-map-info-price">${price} ر.س</div>
            <div class="property-map-info-meta">${area}${rooms}${bathrooms}</div>
            <div class="property-map-info-location">
              <i class="bi bi-geo-alt-fill"></i> ${location}
            </div>
            ${this.detailsLink(row.id)}
          </div>
        </div>
      `;

      this.infoWindow.close();
      this.infoWindow.setContent(content);
      this.infoWindow.open({map: this.map, anchor: marker});

      if(this.infoWindowDomListener)
        window.google.maps.event.removeListener(this.infoWindowDomListener);
      this.infoWindowDomListener = window.google.maps.event.addListenerOnce(this.infoWindow, 'domready', () => {
        const link = document.querySelector(`[data-property-map-id="${Number(row.id)}"]`);
        if(link){
          link.addEventListener('click', event => {
            event.preventDefault();
            this.$router.push({name: 'PropertiesUpdate', params: {id: row.id}});
          }, {once: true});
        }
      });
    },
    detailsLink(id){
      if(!this.checkAccess('property_read'))
        return '';
      const propertyId = Number(id);
      if(!Number.isInteger(propertyId) || propertyId <= 0)
        return '';
      const href = this.$router.resolve({name: 'PropertiesUpdate', params: {id: propertyId}}).href;
      return `<a class="property-map-info-link" data-property-map-id="${propertyId}" href="${this.escapeHtml(href)}">عرض تفاصيل العقار</a>`;
    },
    propertyLocation(row){
      const parts = [];
      if(row.Neighborhood && row.Neighborhood.name)
        parts.push(row.Neighborhood.name);
      if(row.City && row.City.name)
        parts.push(row.City.name);
      return parts.length ? parts.join('، ') : 'الموقع غير محدد';
    },
    escapeHtml(value){
      const element = document.createElement('div');
      element.textContent = String(value ?? '');
      return element.innerHTML;
    },
    clearMapMarkers(){
      this.rows = [];
      this.rowsIds = [];
      this.markers.forEach(marker => marker.setMap(null));
      this.markers = [];
      if(this.infoWindow)
        this.infoWindow.close();
    },
    clearFilters(){
      this.filters = {category: '', purpose: 'null', typeId: 'null'};
      this.$nextTick(() => this.applySelect2Types());
      this.nearProperties(true);
    },
    handleCategoryChange(){
      if(this.filters.typeId !== 'null' &&
        !this.filteredTypesList.some(type => type.id == this.filters.typeId))
        this.filters.typeId = 'null';
      this.$nextTick(() => this.applySelect2Types());
      this.nearProperties(true);
    },
    applySelect2Types(recall=true){
      if(!this.$refs.typesSelect){
        if(recall)
          window.setTimeout(() => this.applySelect2Types(false), 200);
        return;
      }

      const vm = this;
      const $el = $(this.$refs.typesSelect);
      if($el.hasClass('select2-hidden-accessible')){
        $el.off('change.propertyMapTypesSelect2');
        $el.select2('destroy');
      }

      $el.select2({
        width: '100%',
        dir: 'rtl',
      });
      $el.val(this.filters.typeId).trigger('change.select2');
      $el.on('change.propertyMapTypesSelect2', function(){
        const value = $(this).val();
        vm.filters.typeId = value && value !== 'null' ? parseInt(value, 10) : 'null';
        vm.nearProperties(true);
      });
    },
  },
  mounted(){
    if(!this.hasMapAccess){
      this.message = 'غير مصرح لك بعرض خريطة العقارات';
      this.errorNumber = 2289;
      this.hasError = true;
      return;
    }

    Promise.all([this.loadFilterData(), this.loadGoogleMaps()]).then(() => {
      this.initMap();
      this.nearProperties();
    }).catch(err => {
      this.message = err.message;
      this.hasError = true;
      this.loading = false;
    });
  },
  beforeUnmount(){
    if(this.googleLoaderTimer)
      window.clearInterval(this.googleLoaderTimer);
    if(this.mapSearchTimer)
      window.clearTimeout(this.mapSearchTimer);
    if(this.mapIdleListener)
      window.google.maps.event.removeListener(this.mapIdleListener);
    if(this.infoWindowDomListener)
      window.google.maps.event.removeListener(this.infoWindowDomListener);
    if(this.$refs.typesSelect){
      const $el = $(this.$refs.typesSelect);
      if($el.hasClass('select2-hidden-accessible')){
        $el.off('change.propertyMapTypesSelect2');
        $el.select2('destroy');
      }
    }
    this.markers.forEach(marker => marker.setMap(null));
    if(this.infoWindow)
      this.infoWindow.close();
  },
};
</script>

<style scoped>
.map-card {
  min-height: 680px;
  overflow: hidden;
  border: 1px solid #dee2e6;
  border-radius: .5rem;
  background: #f4f6f9;
}

.property-map {
  width: 100%;
  height: 680px;
}

.map-results-count {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 4;
  display: flex;
  align-items: center;
  gap: .35rem;
  padding: .55rem .85rem;
  border-radius: 2rem;
  color: #212529;
  background: rgba(255, 255, 255, .95);
  box-shadow: 0 2px 12px rgba(0, 0, 0, .16);
  font-weight: 700;
}

.map-loading {
  position: absolute;
  top: 1rem;
  left: 50%;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: .65rem;
  padding: .65rem 1rem;
  border-radius: 2rem;
  background: rgba(255, 255, 255, .95);
  box-shadow: 0 2px 12px rgba(0, 0, 0, .18);
  transform: translateX(-50%);
}

.map-loading .spinner-border {
  width: 1.25rem;
  height: 1.25rem;
}

:deep(.property-map-info) {
  display: flex;
  width: 360px;
  max-width: 100%;
  gap: .75rem;
  color: #212529;
  font-family: inherit;
}

:deep(.property-map-info-image) {
  width: 135px;
  height: 115px;
  flex: 0 0 135px;
  border-radius: .45rem;
  object-fit: cover;
}

:deep(.property-map-info-body) {
  min-width: 0;
  flex: 1;
}

:deep(.property-map-info-body strong) {
  display: block;
  margin-bottom: .3rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:deep(.property-map-info-price) {
  margin-bottom: .4rem;
  color: #9b792d;
  font-weight: 700;
}

:deep(.property-map-info-meta) {
  display: flex;
  flex-wrap: wrap;
  gap: .55rem;
  margin-bottom: .35rem;
  color: #5f6770;
  font-size: .82rem;
}

:deep(.property-map-info-location) {
  margin-bottom: .45rem;
  color: #6c757d;
  font-size: .82rem;
}

:deep(.property-map-info-link) {
  color: #85651f;
  font-size: .85rem;
  font-weight: 700;
  text-decoration: none;
}

@media (max-width: 767.98px) {
  .map-card,
  .property-map {
    min-height: 560px;
    height: 560px;
  }

  :deep(.property-map-info) {
    width: 260px;
  }

  :deep(.property-map-info-image) {
    width: 95px;
    height: 100px;
    flex-basis: 95px;
  }
}
</style>
